import styles from './style.module.css';

const Divider = () => {
  return <span className={styles.divider}>|</span>;
};

export default Divider;
